import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import GiftFooter from './components/GiftFooter';
import ItemInfo from './components/ItemInfo';
import useGiftItem from './hooks/useGiftItem';

interface Params {
    giftItemId: string;
}

const GiftItemActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { giftItemId } = params;
    const giftItem = useGiftItem(giftItemId);
    const { t } = useTranslation('gift');

    return (
        <AppScreen>
            {giftItem && (
                <CtaLayout header={<Header title={t('giftItem.title')}/>}
                    footer={<GiftFooter giftItem={giftItem}/>} >
                    <ItemInfo gitItem={giftItem}/>
                </CtaLayout>
            )}
        </AppScreen>
    );
};

export default GiftItemActivity;
